module.exports = __webpack_public_path__ + "img/19_74.bda9cf9d.png";